<app-title icon="recipe_thin" text="Recepti">
  <app-toggle-help>
    Recepti so ključni za kakovost jedilnikov, zato naj temeljijo na živilih iz javnega naročila (vsak zavod vodi svojo bazo receptov). Začnite z vnosom enostavnih receptur (npr. čaji, namazi) in jih postopoma dopolnjujte. Po določenem času boste prišli do lasten kuharske knjige. Recepture lahko opredelite glede na primernost določene medicinsko indicirane diete, sezono, vsebnost alergenov ter kulinarične skupine.
  </app-toggle-help>
</app-title>

<app-main-with-aside>
  <ng-container aside>
    <button class="btn-add-horizontal-large" [routerLink]="['/recipe', 'new']">
      <span>
        Dodaj nov<br>
        recept
      </span>
    </button>
    <form [formGroup]="searchForm">
      <div class="search-box">
        <input formControlName="query" placeholder="Išči recept">
      </div>
      <button class="search-filter--all" type="button" (click)="resetSearchForm()" [class.search-filter--all-inactive]="anyFilter">Vse</button>
      <div class="form-group">
        <app-select-array [options]="allGastro" formControlName="gastro" emptyTitle="Kulinarična skupine" [selectedDark]="true">
        </app-select-array>
      </div>
      <div class="form-group">
        <app-select-array [options]="allSeasons" formControlName="season" emptyTitle="Sezone" [selectedDark]="true"></app-select-array>
      </div>
      <div class="form-group">
        <app-select-array [options]="allDiets" formControlName="diet" emptyTitle="Diete" [selectedDark]="true">
        </app-select-array>
      </div>
    </form>
    <app-food-list [foods]="results" [selected]="recipe?.id" (clicked)="selected($event)" [canDelete]="true" (delete)="delete($event)" (bottom)="loadRecipes()"></app-food-list>
  </ng-container>
  <ng-container main>
    <app-error></app-error>
    <app-recipe-form *ngIf="isNew || recipe" [yearId]="yearId" [recipe]="recipe" (save)="save($event)" [sizes]="sizes" [customDiets]="usedDiets" (dirty)="setDirty($event)">
      <button *ngIf="!isNew && recipe && recipe.id" class="btn-copy" (click)="copy()" type="button">Kopiraj</button>
      <button *ngIf="recipe?.id" class="btn-cancel" type="button" (click)="delete(recipe)">Izbriši</button>
      <app-submit-button #submit></app-submit-button>
    </app-recipe-form>
    <div id="aside-marker"></div>
  </ng-container>
</app-main-with-aside>
<app-general-popup></app-general-popup>